import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { InventoryLevelProfileView } from "src/components/views/erp/warehouse/inventory/InventoryLevelProfileView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/inventoryLevelProfile")({
	staticData: { title: i18n.t("inventory_level_profile"), legacyViewKey: "inventoryLevelProfileView" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <InventoryLevelProfileView isActive={isActive} />;
}
